import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { map } from 'rxjs/operators';

export const DOWNLOAD_DOCUMENT_ENDPOINT_URL = '/account-service/document/';

@Injectable({
  providedIn: 'root',
})
export class DocumentService {

  constructor( private http: HttpClient) {
  }

  getDocumentUri(awsId: string) {
    return `${ environment.serviceUrl }${ DOWNLOAD_DOCUMENT_ENDPOINT_URL }${ awsId }`;
  }

  downloadDocument(awsId: string): any {
    return this.http.get(this.getDocumentUri(awsId), { responseType: 'blob' })
      .pipe(
        map((result: any) => {
          return result;
        }),
      );
  }

}
